import React from 'react';
import Header from 'components/Header/index.tsx';
import NotificationEngine from 'containers/NotificationEngine';
import FormTable from './components/FormTable';
import BreadCrumbFormList from './components/BreadCrumbFormList';
import AddForm from './components/AddForm';

export default function FormListLayout() {

  return (
    <div>
      <Header>
        <NotificationEngine />
        <nav className="bg-white border border-secondary border-top-0 border-left-0 border-right-0 py-3">
          <div className="container">
            <div className="row">
              <BreadCrumbFormList />
              <AddForm />
            </div>
          </div>
        </nav>
      </Header>
      <div className="container">
        <FormTable />
      </div>
    </div>
  );
}
